import * as html from './html.js';

export function ContainerTitleInner({ icon=null }, ...children) {
    return <div class="container__title__text">{icon ? <><i class={icon} />{' '}</> : null}{...children}</div>;
}

export function ContainerTitleAction(props, ...children) {
    props['class'] = html.classes('container__title__action', props['class']);
    return html.element(props.href ? 'a' : 'button', props, ...children);
}

export function ContainerTitle({ title, url=null, icon=null }, ...actions) {
    return <div class="container__title">
        <div class="container__title__background"></div>
        <div class="container__title__inner">
            {url ? <a href={url} class="container__title__link"><ContainerTitleInner icon={icon}>{title}</ContainerTitleInner></a> : <ContainerTitleInner icon={icon}>{title}</ContainerTitleInner>}
            {actions.length > 0 ? <div class="container__title__actions">{...actions}</div> : null}
        </div>
    </div>;
}

export function Checkbox({ name=null, checked=false, value=null, onchange=null, radio=false }, ...children) {
    return <label class={html.classes('input__checkbox', { 'input__checkbox--radio': radio })}>
        <input type={radio ? 'radio' : 'checkbox'} class="input__checkbox__input" name={name} checked={checked} value={value} onchange={onchange} />
        <div class="input__checkbox__display"><div class="input__checkbox__display__icon" /></div>
        <div class="input__checkbox__text">{children}</div>
    </label>;
}
